import * as ActionTypes from 'actions/License';
import * as AuthActionTypes from 'actions/Auth';
import { get } from 'lodash';

const initialState = {
  licenseTemplates: [],
  licenses: [],
  tableFilter: {},
  tableSorting: {},
  sharedLicenseTableSorting: {},
  sharedLicenseTableFilter: {},
  license: null,
  licenseTemplate: null,
  createLicenseModalOpen: false,
  assignLicenseModalOpen: false,
  templateTableFilter: '',
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case AuthActionTypes.LOGOUT.SUCCESS:
      return { ...initialState };
    case ActionTypes.TOGGLE_CREATE_LICENSE_MODAL:
      return {
        ...state,
        createLicenseModalOpen: action.payload,
      };
    case ActionTypes.TOGGLE_ASSIGN_LICENSE_MODAL:
      return {
        ...state,
        assignLicenseModalOpen: action.payload,
      };
    case ActionTypes.GET_LICENSE_TEMPLATES.SUCCESS:
      return {
        ...state,
        licenseTemplates: action.payload,
      };
    case ActionTypes.GET_LICENSE_TEMPLATE.SUCCESS:
      return {
        ...state,
        licenseTemplate: action.payload,
      };
    case ActionTypes.GET_LICENSE.SUCCESS:
      return {
        ...state,
        license: action.payload,
      };
    case ActionTypes.SET_TEMPLATE_TABLE_FILTER:
      return {
        ...state,
        templateTableFilter: action.payload,
      };
    case ActionTypes.SET_LICENSE_TABLE_FILTER:
      return {
        ...state,
        tableFilter: action.payload,
      };
    case ActionTypes.SET_LICENSE_TABLE_SORTING:
      return {
        ...state,
        tableSorting: action.payload,
      };
    case ActionTypes.SET_SHARED_LICENSE_TABLE_SORTING:
      return {
        ...state,
        sharedLicenseTableSorting: action.payload,
      };
    case ActionTypes.SET_SHARED_LICENSE_TABLE_FILTER:
      return {
        ...state,
        sharedLicenseTableFilter: action.payload,
      };
    case ActionTypes.GET_LICENSES.SUCCESS:
      return {
        ...state,
        licenses: get(action.payload, 'content', []),
        licensesPage: get(action, 'payload.currentPage', 0),
        licensesPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_SHARED_LICENSES.SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        sharedLicenses: get(action.payload, 'content', []),
        sharedLicensesPage: get(action, 'payload.currentPage', 0),
        sharedLicensesPages: get(action, 'payload.totalPages', 0),
      };
    default:
      return state;
  }
}
